<template>
  <div id="app">
    <h1 class="title">GBF 羅盤儀</h1>
    <!--img alt="Vue logo" src="./assets/logo.png"-->
    <!--HelloWorld msg="Welcome to Your Vue.js App"/-->
    <SearchBox msg="start the first box"/>
    <!--ScrollMap msg="world map"/-->
    <!--WorldMap msg="full world map"/-->
    <back-to-top text="" visibleoffset="400"></back-to-top>

  </div>
</template>

<script>
//import HelloWorld from './components/HelloWorld.vue'
//import SearchBox from "./components/search.vue";
import SearchBox from "./components/BigBox.vue";
//import ScrollMap from "./components/ScrollFinder.vue";
//import WorldMap from "./components/Map.vue";
//import IslandPack from './components/IslandName.vue'
//Vue.use(IslandPack);

import Vue from "vue";
import VueScrollTo from "vue-scrollto";
import Multiselect from "vue-multiselect";
import BackToTop from "vue-backtotop";




// Loading the plugin into the Vue.

export const LightEvent = new Vue();
Vue.use(BackToTop);

Vue.use(VueScrollTo);
// register globally
Vue.component("multiselect", Multiselect);

export default {
  name: "app",
  components: {
    //    HelloWorld
    SearchBox,
    //ScrollMap,
    //WorldMap,
//    Multiselect,
    BackToTop
  }
};
</script>

<style>

body {
  min-width: 320px;
  width: 640px; /* 看使用者實際反應再加回去 */
  max-width: 640px;
  background-color: #4e4e4e;
  color: #c4f9ff;
}
.title {
  color: #c4f9ff;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /*color: #2c3e50;*/
  color: #c4f9ff;

  margin-top: 6%;
}

.btn-to-top {
  left: 10px;
  width: 60px;
  height: 60px;
  padding: 10px 16px;
  border-radius: 50%;
  font-size: 22px;
  line-height: 22px;
}
.vue-back-to-top .default{
  left: 10px;
  width: 70px;
  height: 70px;
  background-position: 0px 150px;
  background-image: url("https://i.imgur.com/LpibKUi.png");
  background-color: rgb(0,0,0,0);
}
</style>
